import { observer } from 'mobx-react';
import { Resizable } from 're-resizable';
import { Outlet } from 'react-router-dom';

import { config, getEnable } from './panel.config';
import { PanelWrapper } from './panel.style';
import { Side, type Width } from './panel.type';

type PanelProps = {
  side?: Side;
  width?: Partial<Width>;
};

const Panel = ({ side = Side.Right, width = {} }: PanelProps) => {
  const widthProp: Width = {
    ...config.width,
    ...width
  };

  return (
    <PanelWrapper
      $side={side}
      animate={{
        x: 0,
        opacity: 1
      }}
      className="shadow-md outline outline-1 outline-gray-200"
      exit={{
        x: widthProp.max
      }}
      initial={{
        x: widthProp.default,
        opacity: 0
      }}
      transition={{
        duration: 0.3,
        ease: 'anticipate'
      }}
    >
      <Resizable
        defaultSize={{ width: widthProp.default, height: '100%' }}
        enable={getEnable(side)}
        maxWidth={widthProp.max}
        minWidth={widthProp.min}
      >
        <Outlet />
      </Resizable>
    </PanelWrapper>
  );
};

const PanelObserver = observer(Panel);
export default PanelObserver;
